export const environment = {
  production: false,
  showStagingWatermark: true,
  apiDomain: 'argo.ml3ds-rt-stage.com',
  productDataPath: 'https://argo.ml3ds-rt-stage.com/productdata',
  buildNumber: '995',
  useServiceWorker: true,
  useUseBerry: false
};
